import { render } from "./chon-vi-tri-cho-ngoi.vue?vue&type=template&id=0e217c3c&scoped=true"
import script from "./chon-vi-tri-cho-ngoi.vue?vue&type=script&lang=js"
export * from "./chon-vi-tri-cho-ngoi.vue?vue&type=script&lang=js"

import "./chon-vi-tri-cho-ngoi.vue?vue&type=style&index=0&id=0e217c3c&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e217c3c"]])

export default __exports__